module.exports = __webpack_public_path__ + "images/ernstyoung_small6070c34f9686981710c8c792d71e4260.png";